import { gsap } from 'gsap'
import { deepMerge, getCubicCurve } from 'js/utils/Utils'
import BaseSlideshow from 'js/modules/_base/ui/slideshow/BaseSlideshow'

const defaults = {
  instanceName: 'webGLMakSlideshow',
  timerInfo: {
    duration: 4,
  },
  effectInfo: {
    maskStaggerDelay: 0.125,
  },
}

export default class WebGLMakSlideshow extends BaseSlideshow {
  mesh = []
  constructor(options = {}) {
    super()

    this.callback = {
      next: async () => {
        await new Promise((resolve) => {
          if (this.mesh) {
            gsap.killTweensOf(this.mesh.uniforms.uSlideshowProgress)

            gsap.to(this.mesh.uniforms.uSlideshowProgress1, {
              value: 1,
              ease: 'cubic.inOut',
              duration: 1,
            })

            gsap.to(this.mesh.uniforms.uSlideshowProgress2, {
              value: 1,
              ease: 'cubic.inOut',
              duration: 1,
              delay: this.effectInfo.maskStaggerDelay,
            })

            gsap.to(this.mesh.uniforms.uSlideshowProgress3, {
              value: 1,
              ease: 'cubic.inOut',
              duration: 1,
              delay: this.effectInfo.maskStaggerDelay * 2,
              onComplete: () => {
                if (this.mesh) {
                  requestAnimationFrame(() => {
                    this.mesh.currentIndex = (this.mesh.currentIndex + 1) % this.mesh.textures.length
                    const nextIndex = (this.mesh.currentIndex + 1) % this.mesh.textures.length

                    this.mesh.uniforms.uSlideshowProgress3.value = 0
                    this.mesh.uniforms.uSlideshowProgress1.value = 0
                    this.mesh.uniforms.uSlideshowProgress2.value = 0
                    this.mesh.uniforms.uCurrentTexture.value = this.mesh.textures[this.mesh.currentIndex]
                    this.mesh.uniforms.uNextTexture.value = this.mesh.textures[nextIndex]
                    this.mesh.uniforms.uCurrentTextureResolution.value.x = this.mesh.textures[this.mesh.currentIndex].image.naturalWidth
                    this.mesh.uniforms.uCurrentTextureResolution.value.y = this.mesh.textures[this.mesh.currentIndex].image.naturalHeight
                    this.mesh.uniforms.uNextTextureResolution.value.x = this.mesh.textures[nextIndex].image.naturalWidth
                    this.mesh.uniforms.uNextTextureResolution.value.y = this.mesh.textures[nextIndex].image.naturalHeight
                  })
                }
              },
            })
          }

          resolve()
        })
      },
      prev: async () => {
        await new Promise((resolve) => resolve())
      },
      updateIndicator: async () => {
        await new Promise((resolve) => resolve())
      },
    }

    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
  }

  destroy() {
    super.destroy()
    this.mesh = null
  }
}